import React, { FC, useEffect, useState } from 'react'
import { Button, Typography } from '@material-ui/core'
import { useTagTextWrapperStyles } from './tag-text-wrapper.styles'
import { useTranslation } from '@plandi/common'

interface ITagTextWrapperProps {
  text?: string
}
export const TagTextWrapper: FC<ITagTextWrapperProps> = ({ text }) => {
  const [textSeo, setTextSeo] = useState('')
  const [isHidden, setHidden] = useState(true)

  const { data: translate } = useTranslation()

  const classes = useTagTextWrapperStyles()

  useEffect(() => {
    if (text) {
      setTextSeo(text)
    }
  }, [text])

  const parsedText = React.useMemo(() => {
    if (!textSeo) return
    const parser = new DOMParser()
    const doc = parser.parseFromString(textSeo, 'text/html')
    const headings = doc.getElementsByTagName('h1')
    const paragraphs = doc.getElementsByTagName('p')
    return { headings, paragraphs }
  }, [textSeo])

  return (
    <div className={classes.root}>
      {!textSeo && text && (
        <Typography
          variant="body1"
          component={'div'}
          className={classes.text}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}

      {!isHidden ? (
        textSeo.includes('<') ? (
          <Typography
            variant="body1"
            className={classes.text}
            dangerouslySetInnerHTML={{ __html: text || '' }}
          />
        ) : (
          <Typography variant="body1" className={classes.text}>
            {textSeo}
          </Typography>
        )
      ) : textSeo.includes('<') ? (
        <>
          <Typography
            variant="body1"
            className={classes.text}
            dangerouslySetInnerHTML={{
              __html: parsedText?.headings?.[0]?.outerHTML || ''
            }}
          />
          <Typography
            variant="body1"
            className={classes.text}
            dangerouslySetInnerHTML={{
              __html: parsedText?.paragraphs?.[0]?.outerHTML || ''
            }}
          />
        </>
      ) : (
        <Typography variant="body1" className={classes.text}>
          {textSeo}
        </Typography>
      )}
      {text && text.length > 150 && (
        <div style={{ alignSelf: 'flex-end' }}>
          <Button
            variant={'contained'}
            color={'default'}
            onClick={() => setHidden((prevState) => !prevState)}
            disableElevation
          >
            {isHidden
              ? translate?.shop?.['read-more'] ?? 'Читать далее'
              : translate?.shop?.collapse ?? 'Свернуть'}
          </Button>
        </div>
      )}
    </div>
  )
}
